import React, { useEffect, useRef, useState } from 'react';
import createApp from "@shopify/app-bridge";

import { request } from '../api';
import { processOAuth } from '../service';
import { requestShopifyPosKiosk } from './ShopifyPOS';
import config from '../config';

const queryParams = new URLSearchParams(window.location.search);
const embedded = queryParams.get('embedded');
const host = queryParams.get('host');


function isShopifyPOS() {
  return typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Shopify POS') >= 0;
}


export default function ShopifyOAuthInstall() {
  const [isShopifyAdmin, setShopifyAdmin] = useState(false);
  const [error, setError] = useState();
  const appRef = useRef(
    // funny thing, when reading Shopify docs one might think forceRedirect option
    // defaults to false, but no sir! it's TRUE by default.
    //
    // what's in the docs:
    //
    // forceRedirect (Optional) - If set to true, then App Bridge detects when your app is loaded
    // outside of the Shopify admin, and automatically redirects the user to the Shopify admin page
    // that embeds your app.
    createApp({ apiKey: config.SHOPIFY_API_KEY, host, forceRedirect: false })
  )

  useEffect(() => {
    const resolve = async () => {
      // inside Shopify POS
      if (isShopifyPOS()) {
        setError("Looking for POS user...");

        const pos = await appRef.current.getState('pos');

        if (pos.user) {
          setError("Found " + JSON.stringify(pos.user));

          try {
            const { url } = await requestShopifyPosKiosk(pos.user.id, queryParams);
            setError("Initializing session...");
            window.location.href = `${url}&staffId=${pos.user.id}`;
            return;
          } catch(e) {
            setError(e.message);
          }
        } else {
          setError("Something's terribly wrong here");
        }

        return;
      }

      // inside Shopify Admin
      if (embedded) { 
        setShopifyAdmin(true);
        return;
      }

      const response = await request(`integrations/shopify`);
      setError("Redirecting...");
      processOAuth(response, queryParams)
      return;
    }

    resolve();
  }, []);

  return (
    <div>
      {isShopifyAdmin ? (
        <a href={config.APP_URL} target="_blank" rel="noopener noreferrer">
          Click here to go to Sling
        </a>
      ) : <div>{error}</div>}
    </div>
  )
}
